<template>
  <div>
    <breadcrumbs :crumbs="[{name:'Administrative Settings'},{name:'Form List', link:'Form Builder Index'}, {name: 'Field Templates'}]"/>
    <spinner v-if="loading"></spinner>
    <div v-else class="portlet light">
      <div class="portlet-title">
        <div class="caption caption-md">
          <span class="caption-subject bold uppercase">Field Template</span>
        </div>
      </div>
      <div class="portlet-body">
        <form data-vv-scope="field-template" class="row">
          <div class="col-md-5">
            <form-input
              v-model="template.name"
              label="Name"
              name="template-name"
              validation-scope="field-template"
              validators="required"
            />
            <form-input
              v-model="template.description"
              label="Description"
              name="template-description"
              validation-scope="field-template"
              validators="required"
            />
          </div>
          <div class="col-md-7">
            <editor-options-list
              :values="template.options"
              id="template"
              :edit-value="true"
            />
          </div>
          <div class="col-md-12">
            <button class="btn green" @click.prevent="save()">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';

import Breadcrumbs from '@/components/Breadcrumbs'
import EditorOptionsList from "@/components/formbuilder/editors/EditorOptionsList";
import FormInput from "@/components/forms/FormInput";
import Spinner from '@/components/Spinner';

export default {
  components: {
    Breadcrumbs,
    EditorOptionsList,
    FormInput,
    Spinner,
  },
  computed: {
    ...mapGetters({
      loading: 'fieldTemplates/getLoading',
      template: 'fieldTemplates/getCurrentFieldTemplate',
    })
  },
  methods: {
    ...mapActions({
      fetchFieldTemplateById: 'fieldTemplates/fetchFieldTemplateById',
      updateFieldTemplate: 'fieldTemplates/updateFieldTemplate',
      createFieldTemplate: 'fieldTemplates/createFieldTemplate',
    }),
    ...mapMutations({
      setCurrentTemplate: 'fieldTemplates/SET_CURRENT_TEMPLATE'
    }),
    async save() {
      if (await this.$validator.validateAll('field-template') && this.template.options.length > 0) {
        if (this.template.id) {
          this.updateFieldTemplate(this.template).then(() => {
            this.$notify('Template saved');
          });
        } else {
          this.createFieldTemplate(this.template).then(() => {
            this.$notify('Template created');
            this.$router.push({name: 'Form Builder Index'});
          })
        }
      }
    }
  },
  mounted () {
    if (this.$route.params.id) {
      this.fetchFieldTemplateById({id: parseInt(this.$route.params.id)});
    } else {
      this.setCurrentTemplate({
        id: null,
        name: '',
        description: '',
        options: [],
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// EditFieldTemplate.vue?081d6aff